export enum UserAdminVerificationStatusEnum {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    BLOCKED = 'BLOCKED'
}
export class UserValuesData {

    public static userAdminStatuses: any[] = [
        {id: UserAdminVerificationStatusEnum.PENDING, nameEN: 'Pending', nameHE: 'ממתין לאישור'},
        {id: UserAdminVerificationStatusEnum.APPROVED, nameEN: 'Approved', nameHE: 'מאושר'},
        {id: UserAdminVerificationStatusEnum.BLOCKED, nameEN: 'Blocked', nameHE: 'חסום'},
    ];

    public static DEFAULT_USER_EMAIL = 'education.lectures@spaceil.com';
}
